import { render, staticRenderFns } from "./TopicsIndex.vue?vue&type=template&id=daba9b52"
import script from "./TopicsIndex.vue?vue&type=script&lang=js"
export * from "./TopicsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports